const CaseReportCardSkeleton = ({ selectable = false }) => {
  return (
    <div className="flex items-center gap-3">
      {selectable && (
        <div className="cursor-not-allowed w-[22px] h-[22px] border-2 border-[#D9D9D9] rounded-full" />
      )}

      <div
        className="flex flex-col w-full h-[110px] gap-5 p-3 border-[2px] border-gray-2 rounded-[12px] cursor-not-allowed
       bg-white"
      >
        <div className="flex justify-between w-full">
          <div className="animate-pulse bg-[#D9D9D9] h-[26px] w-[85px] rounded-[10px]" />
          <div className="animate-pulse bg-[#D9D9D9] h-[26px] w-[85px] rounded-[10px]" />
        </div>

        <div className="flex justify-between items-end w-full">
          <div className="flex flex-col gap-[5px]">
            <div className="animate-pulse w-[64px] h-[15px] rounded-[10px] bg-[#D9D9D9]" />
            <div className="animate-pulse w-[109px] h-[15px] rounded-[10px] bg-[#D9D9D9]" />
          </div>

          <div className="animate-pulse w-[106.22px] h-[15px] rounded-[10px] bg-[#D9D9D9]" />
        </div>
      </div>
    </div>
  );
};

export default CaseReportCardSkeleton;
